import { connect } from 'react-redux'

import { startOnScreenRecoverySubscriptionFlow, selectPauseReason } from 'actions/onScreenRecovery'
import { getAccessToken } from 'selectors/auth'
import { getBrowserType } from 'selectors/browser'
import { getShouldClosePauseReasonsView } from 'selectors/subscription'
import { isMobile } from 'utils/view'

import { Subscription } from './Subscription'

const mapStateToProps = (state) => ({
  accessToken: getAccessToken(state),
  isMobile: isMobile(getBrowserType(state)),
  shouldClosePauseReasonsView: getShouldClosePauseReasonsView(state),
})

const SubscriptionContainer = connect(mapStateToProps, {
  startOnScreenRecoverySubscriptionFlow,
  selectPauseReason,
})(Subscription)

export { SubscriptionContainer }
